import { createAppSlice } from 'app/createAppSlice'
import moment from 'moment-timezone'
import {
  checkSellerInfo,
  createOrder,
  getComodities,
  getInventories,
  getInventorySelection,
  getPackings,
  uploadFile,
} from './sellCommodityAction'

const initialState = {
  addItemCount: [1],
  isOpenModal: false,
  isOpenModalDraft: false,
  orders: {
    isLoading: false,
    userId: null,
    item: [
      {
        orderItemId: 1,
        SKU: '',
        amount: '',
        imageUrl: '',
        nameItem: '',
        price: '',
        totalPrice: '',
        unit: {
          label: 'Kg',
          value: 'Kg',
        },
      },
    ],
    order: {
      type: 'SELL',
      notes: '',
      transaction_number: '',
      files: [],
    },
    buyer: null,
    seller: null,
    isSuccess: false,
    message: '',
    trxDate: moment(new Date()).format('YYYY-MM-DD'),
    project: null,
  },
  invPacking: [],
  comodities: null,
  inventories: null,
  packings: null,
  packs: null,
  isOpenModalUnregis: false,
  isLoading: false,
  inventorySelection: [],
}

export const sellCommoditySlice = createAppSlice({
  name: 'sell/commodity',
  initialState,
  reducers: (create) => ({
    addItem: create.reducer((state) => {
      let count = state.addItemCount[state.addItemCount.length - 1] + 1
      state.orders.item = [
        ...state.orders.item,
        {
          orderItemId: count,
          SKU: '',
          amount: '',
          imageUrl: '',
          nameItem: '',
          price: '',
          totalPrice: '',
          unit: {
            label: 'Kg',
            value: 'Kg',
          },
        },
      ]
      state.addItemCount.push(count)
    }),
    setTrxDate: create.reducer((state, { payload }) => {
      state.orders.trxDate = moment(payload).format('YYYY-MM-DD')
    }),
    setProject: create.reducer((state, { payload }) => {
      state.orders.project = payload
    }),
    setInitialTrx: create.reducer((state, { payload }) => {
      state.orders = {
        isLoading: false,
        userId: null,
        item: [
          {
            orderItemId: 1,
            SKU: '',
            amount: '',
            imageUrl: '',
            nameItem: '',
            price: '',
            totalPrice: '',
            unit: {
              label: 'Kg',
              value: 'Kg',
            },
          },
        ],
        order: {
          type: 'SELL',
          notes: '',
          transaction_number: '',
          files: [],
        },
        buyer: null,
        seller: null,
        isSuccess: false,
        message: '',
        trxDate: moment(new Date()).format('YYYY-MM-DD'),
        project: null,
      }
    }),
    setInitialBuyer: create.reducer((state, { payload }) => {
      state.orders.buyer = payload
    }),
    removeItem: create.reducer((state, { payload }) => {
      const filteredArr = state.addItemCount.filter((item) => item !== payload)
      const filteredPack = state.invPacking.filter(
        (item) => item?.fieldNum !== payload,
      )
      state.orders.item = state.orders.item.filter(
        (item) => item.orderItemId !== payload,
      )
      if (filteredArr.length === 0) {
        state.addItemCount = [1]
        state.orders.item = [
          {
            orderItemId: 1,
            SKU: '',
            amount: '',
            imageUrl: '',
            nameItem: '',
            price: '',
            totalPrice: '',
            unit: { label: 'Kg', value: 'Kg' },
          },
        ]
        state.invPacking = []
      } else {
        state.addItemCount = filteredArr
        state.invPacking = filteredPack
      }
    }),
    removePacking: create.reducer((state, { payload }) => {
      const filteredPack = state.invPacking.filter(
        (item) => item?.fieldNum !== payload,
      )
      state.invPacking = filteredPack
    }),
    toggleModal: create.reducer((state) => {
      state.isOpenModal = !state.isOpenModal
    }),
    toggleModalUnregis: create.reducer((state) => {
      state.isOpenModalUnregis = !state.isOpenModalUnregis
    }),
    setInvPacking: create.reducer((state, { payload }) => {
      state.invPacking = payload
    }),
    updateInvPacking: create.reducer((state, { payload }) => {
      const newData = Array.isArray(payload) ? payload : [payload]
      const filtered = state.invPacking.filter(
        (existingItem) =>
          !newData.some((newItem) => newItem.fieldNum === existingItem.fieldNum),
      )
      state.invPacking = [...filtered, ...newData].sort(
        (a, b) => (a.itemId ?? 0) - (b.itemId ?? 0),
      )
    }),
    stepOrder: create.reducer((state, { payload }) => {
      state.orders.order.type = payload.type
      state.orders.step = payload.step
    }),
    setOrders: create.reducer((state, { payload }) => {
      state.orders = payload
    }),
    setOrdersPayload: create.reducer((state, { payload }) => {
      state.orders.item = payload
    }),
    setOrdersNote: create.reducer((state, { payload }) => {
      state.orders.order.notes = payload ?? ''
    }),
    setOrdersCustomTrx: create.reducer((state, { payload }) => {
      state.orders.order.transaction_number = payload ?? ''
    }),
    setOrderSeller: create.reducer((state, { payload }) => {
      state.orders.seller = payload
      state.orders.userId = payload.userId
    }),
    setRemoveDoc: create.reducer((state, { payload }) => {
      const targetUrl = typeof payload === 'string' ? payload : payload?.url
      if (targetUrl) {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (fileUrl) => fileUrl !== targetUrl,
        )
      } else if (
        typeof payload?.id === 'string' &&
        (payload.id.startsWith('http://') || payload.id.startsWith('https://'))
      ) {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (fileUrl) => fileUrl !== payload.id,
        )
      } else if (typeof payload?.index === 'number') {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (_, index) => index !== payload.index,
        )
      } else if (typeof payload?.id === 'number') {
        state.orders.order.files = (state.orders.order.files || []).filter(
          (_, index) => index !== payload.id,
        )
      }
    }),
    setInitStateSell: create.reducer((state) => {
      state.addItemCount = [1]
      state.isOpenModal = false
      state.orders = {
        ...state.orders,
        isLoading: false,
        userId: null,
        order: {
          type: 'SELL',
          notes: '',
          files: [],
        },
        buyer: null,
        seller: null,
        isSuccess: false,
        message: '',
        project: null,
      }
    }),
    resetItemToDefault: create.reducer((state, { payload }) => {
      const { type, fieldNum } = payload

      const itemIndex = state.orders.item.findIndex(
        (item) => item.orderItemId === fieldNum,
      )

      if (itemIndex === -1) return

      if (type === 'komoditas_umum') {
        state.orders.item[itemIndex] = {
          orderItemId: fieldNum,
          SKU: '',
          amount: '',
          imageUrl: '',
          nameItem: '',
          price: '',
          totalPrice: '',
          unit: { label: 'Kg', value: 'Kg' },
        }
      } else if (type === 'inventori_anda') {
        state.orders.item[itemIndex] = {
          orderItemId: fieldNum,
          SKU: '',
          amount: '',
          imageUrl: '',
          nameItem: '',
          price: '',
          totalPrice: '',
          unit: '',
        }
      }

      state.invPacking = state.invPacking.filter(
        (item) => item.fieldNum !== fieldNum,
      )
    }),
    resetSellCommodityState: create.reducer((state) => {
      state.addItemCount = initialState.addItemCount
      state.isOpenModal = initialState.isOpenModal
      state.isOpenModalDraft = initialState.isOpenModalDraft
      state.orders = initialState.orders
      state.invPacking = initialState.invPacking
      state.packs = initialState.packs
      state.isOpenModalUnregis = initialState.isOpenModalUnregis
      state.isLoading = initialState.isLoading
      state.inventorySelection = initialState.inventorySelection
      // We explicitly DO NOT reset comodities, inventories, and packings
      // to allow for Smart Sync / Stale-While-Revalidate behavior.
    }),
    toggleAllowPayment: create.reducer((state, { payload }) => {
      const key = payload
      const currentValue = state.orders.buyer?.allowPayment?.[key] ?? 0

      if (!state.orders.buyer) return

      if (!state.orders.buyer.allowPayment) {
        state.orders.buyer.allowPayment = {}
      }

      state.orders.buyer.allowPayment[key] = currentValue === 1 ? 0 : 1
    }),
    toggleAllowPaymentByValue: create.reducer((state, { payload }) => {
      const { key, value } = payload

      if (!state.orders.buyer) return

      if (!state.orders.buyer.allowPayment) {
        state.orders.buyer.allowPayment = {}
      }

      state.orders.buyer.allowPayment[key] = value
    }),
    toggleModalDraft: create.reducer((state) => {
      state.isOpenModalDraft = !state.isOpenModalDraft
    }),
    setItemCount: create.reducer((state, { payload }) => {
      state.addItemCount = payload
    }),
  }),
  extraReducers: (builder) => {
    builder
      .addCase(checkSellerInfo.pending, (state) => {
        state.orders.isLoading = true
      })
      .addCase(checkSellerInfo.fulfilled, (state, { payload }) => {
        state.orders.isLoading = false
        state.orders.buyer = payload
      })
      .addCase(checkSellerInfo.rejected, (state, { payload }) => {
        state.orders.isLoading = false
      })
      .addCase(createOrder.pending, (state) => {
        state.orders.isLoading = true
        state.orders.isSuccess = false
      })
      .addCase(createOrder.fulfilled, (state, { payload }) => {
        state.orders.isLoading = false
        state.orders.isSuccess = true
      })
      .addCase(createOrder.rejected, (state, { payloads }) => {
        state.orders.isLoading = false
        state.orders.isSuccess = false
      })
      .addCase(uploadFile.pending, (state) => {
        state.orders.isLoading = true
      })
      .addCase(uploadFile.fulfilled, (state, { payload }) => {
        state.orders.isLoading = false
        const uploadedUrl =
          payload?.url ||
          payload?.data?.url ||
          (typeof payload === 'string' ? payload : null)

        if (uploadedUrl && typeof uploadedUrl === 'string') {
          const currentFiles = state.orders.order.files || []
          if (!currentFiles.includes(uploadedUrl)) {
            state.orders.order.files = [...currentFiles, uploadedUrl]
          }
        }
      })
      .addCase(uploadFile.rejected, (state, { payload }) => {
        state.orders.isLoading = false
      })
      .addCase(getComodities.fulfilled, (state, { payload }) => {
        state.comodities = payload
        state.isLoading = false
      })
      .addCase(getComodities.pending, (state) => {
        if (!state.comodities || state.comodities.length === 0) {
          state.isLoading = true
        }
      })
      .addCase(getInventories.fulfilled, (state, { payload }) => {
        state.inventories = payload
        state.isLoading = false
      })
      .addCase(getInventories.pending, (state) => {
        if (!state.inventories || state.inventories.length === 0) {
          state.isLoading = true
        }
      })
      .addCase(getPackings.fulfilled, (state, { payload }) => {
        state.packings = payload
        state.isLoading = false
      })
      .addCase(getPackings.pending, (state) => {
        if (!state.packings || state.packings.length === 0) {
          state.isLoading = true
        }
      })
      .addCase(getInventorySelection.fulfilled, (state, action) => {
        state.inventorySelection = action.payload
      })
  },
})

export const {
  addItem,
  removeItem,
  toggleModal,
  stepOrder,
  setOrdersPayload,
  setOrdersNote,
  setOrderBuyer,
  setOrderSeller,
  setRemoveDoc,
  setInitStateSell,
  setInitialBuyer,
  setInvPacking,
  updateInvPacking,
  removePacking,
  toggleModalUnregis,
  setOrdersCustomTrx,
  setTrxDate,
  resetItemToDefault,
  resetSellCommodityState,
  toggleAllowPayment,
  toggleAllowPaymentByValue,
  setInitialTrx,
  toggleModalDraft,
  setOrders,
  setItemCount,
  setProject,
} = sellCommoditySlice.actions

export default sellCommoditySlice.reducer
